import { requestApi } from '~/services/api-new';
import { InitiateCddnResponse } from './response.types';
import { SessionCriteriaResponse } from '../../../api/response.types';
import { CddnRegisterPayload } from './payload.types';

const BASE_URL = '/rest/cddn';

export const getCddnUrlCall = () => {
	// rest/cddn/initiate
	return requestApi<InitiateCddnResponse>({ endpoint: `${BASE_URL}/initiate` });
};

export const cddnRegisterCall = (payload: CddnRegisterPayload) => {
	// /rest/cddn/register
	return requestApi<SessionCriteriaResponse>({ endpoint: `${BASE_URL}/register`, payload, method: 'POST' });
};
